/* Klikk og hent, correction K1: under 750px the Shopify Inbox launcher sits
   fixed in the bottom right corner, over the delivery choice, "Velg butikk"
   and the buy and checkout buttons as they scroll past, and takes the tap.
   While any of them is in the viewport, html carries bjerve-kjop-synlig and
   bjerve-tokens.css steps the closed launcher aside. The width rule lives in
   the CSS, so this script only reports what is in view. A first pass with
   getBoundingClientRect sets the class before the observer's first callback;
   a body MutationObserver picks up the controls Dawn re-renders (the cart
   drawer, variant changes, quick add) and lets go of the removed ones. */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var KONTROLLER = '.bjerve-levering, [data-bjerve-velg-butikk], .product-form__buttons, .cart__ctas';
  var rot = document.documentElement;
  var fulgt = new Set();
  var synlige = new Set();

  function oppdater() {
    rot.classList.toggle('bjerve-kjop-synlig', synlige.size > 0);
  }

  var observator = new IntersectionObserver(function (oppforinger) {
    oppforinger.forEach(function (o) {
      if (o.isIntersecting && fulgt.has(o.target)) synlige.add(o.target);
      else synlige.delete(o.target);
    });
    oppdater();
  });

  function iVinduet(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.right > 0 && r.top < window.innerHeight && r.left < window.innerWidth;
  }

  function skann() {
    fulgt.forEach(function (el) {
      if (el.isConnected) return;
      observator.unobserve(el);
      fulgt.delete(el);
      synlige.delete(el);
    });
    document.querySelectorAll(KONTROLLER).forEach(function (el) {
      if (fulgt.has(el)) return;
      fulgt.add(el);
      if (iVinduet(el)) synlige.add(el);
      observator.observe(el);
    });
    oppdater();
  }

  skann();

  var planlagt = false;
  new MutationObserver(function () {
    if (planlagt) return;
    planlagt = true;
    requestAnimationFrame(function () {
      planlagt = false;
      skann();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
